<template>
  <div>
    <Breadcrumbs
      main-link="welcome"
      :main="$t('dashboardVue.dashboard')"
      :title="$t('faqPage.faq')"
    />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-8 ">
          <h3 class="mb-3">
            {{ $t('sidebar.teztezVerilnSuallar') }}
          </h3>

          <p class="lead">
            {{ $t('faqPage.buBlmdSiziMaraqlandranSuallaraCavabAlaBilrsiniz') }}
          </p>


          <div
            id="accordion"
            class=" default-according style-1 faq-accordion"
          >
            <b-card
              v-for="f in faq"
              :key="f.id"
              no-body
            >
              <b-card-header
                header-tag="div"
                role="tab"
              >
                <h5 class="mb-0">
                  <button
                    class="btn btn-link collapsed pl-0"
                    @click="toggleCollapses('faq_'+f.id)"
                  >
                    <feather type="help-circle" />
                    {{ f.title }}
                  </button>
                </h5>
              </b-card-header>
              <b-collapse
                :id="`faq_${f.id}`"
                role="tabpanel"
              >
                <b-card-body
                  style="white-space: pre-wrap"
                  v-html="f.text"
                />
              </b-collapse>
            </b-card>
          </div>
        </div>
        <div class="col-xl-4 ">
          <router-link
            class="btn btn-lg w-100 btn-outline-dark"
            :to="{name: 'advices'}"
          >
            {{ $t('advices.tvsiylr') }}
          </router-link>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
<script>
import {mapState} from "vuex";
import {getInfoBlockList} from "@/repositories/GeneralDataRepository";
import {mediaBase} from "@/repositories/Repository";

export default {
  data() {
    return {
      mediaBase: mediaBase,
      faq: [],
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),
  },

  mounted() {
    this.getFaq();
  },

  methods: {
    getFaq() {
      const languageMap = {
        az: 1,
        en: 2,
        ru: 3
      };
      const currentLocale = this.$i18n.locale;

      const languageId = languageMap[currentLocale];
      getInfoBlockList('faq', languageId).then(data => {
        if (data.code === 200) {
          this.faq = data.blocks;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          }).then(() => {
            window.location.reload();
          })
        }
      })
    },
    toggleCollapses(id) {
      this.$root.$emit('bv::toggle::collapse', id)
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
